import React from "react";
import { buttonStyle, tdStyle, thStyle } from "./eventStyles";

/**
 * Read-only table of events with row actions (edit, activate/deactivate, complete) and a create entry point.
 * Delegates mutations to parent handlers so this component stays free of API and loading concerns.
 */
const EventList = ({ events, onCreate, onEdit, onSetEventState }) => (
    <div>
        <h2>Event List</h2>
        <table style={{ width: 'auto', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
            <thead>
                <tr style={{ backgroundColor: '#f2f2f2' }}>
                    <th style={thStyle}>Event Name</th>
                    <th style={thStyle}>Event State</th>
                    <th style={thStyle}>App Name</th>
                    <th style={thStyle}>Event Date</th>
                    <th style={thStyle}>Event Link</th>
                    <th style={thStyle}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {events.map((event) => (
                    <tr key={event.event_id} style={{ borderBottom: '1px solid #ddd' }}>
                        <td style={tdStyle}>{event.event_name}</td>
                        <td style={tdStyle}>{event.event_state}</td>
                        <td style={tdStyle}>{event.app_name}</td>
                        <td style={tdStyle}>{event.event_date}</td>
                        {event.event_state === 'completed' ? (
                            <td style={tdStyle}>N/A</td>
                        ) : (
                            <td style={tdStyle}>
                                <a href={`https://${event.event_page_url}`} target="_blank" rel="noreferrer">
                                    Event Link
                                </a>
                            </td>
                        )}
                        <td style={tdStyle}>
                            {event.event_state !== 'completed' ? (
                                <>
                                    <button onClick={() => onEdit(event.event_id)} style={buttonStyle}>
                                        Edit
                                    </button>
                                    <button
                                        style={buttonStyle}
                                        onClick={() => onSetEventState(event.event_id, event.event_state)}
                                    >
                                        {event.event_state === 'active' ? 'Deactivate' : 'Activate'}
                                    </button>
                                    <button
                                        style={buttonStyle}
                                        onClick={() => onSetEventState(event.event_id, 'completed')}
                                    >
                                        Mark as Completed
                                    </button>
                                </>
                            ) : null}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        <button onClick={onCreate} style={buttonStyle}>
            Create New Event
        </button>
    </div>
);

export default EventList;
